/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EligibilityCriteriaResponse } from '../models/EligibilityCriteriaResponse';
import type { EligibilityEvaluationResponse } from '../models/EligibilityEvaluationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EligibilityRoutesRepository {
  /**
   * Get Eligibility Result
   * Get latest eligibility result for a job_program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static eligibilityRoutesGetEligibilityResult({
    jobId,
    jobProgramId,
    authorization,
  }: {
    jobId: any,
    jobProgramId: any,
    authorization?: string,
  }): CancelablePromise<(EligibilityEvaluationResponse | null)> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/eligibility/{job_id}/eligibility_result/{job_program_id}',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Eligibility Results
   * Get latest eligibility result for a job_program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static eligibilityRoutesGetEligibilityResults({
    jobId,
    authorization,
  }: {
    jobId: any,
    authorization?: string,
  }): CancelablePromise<(Array<EligibilityEvaluationResponse> | null)> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/eligibility/{job_id}/eligibility_results',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Reevaluate Eligibility Criteria
   * Re-evaluate eligibility criteria for every program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static eligibilityRoutesReevaluateEligibilityCriteria({
    jobId,
    authorization,
  }: {
    jobId: any,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/eligibility/{job_id}/reevaluate_eligibility_criteria',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Reevaluate Jp Eligibility Criteria
   * Re-evaluate eligibility criteria for a specific job program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static eligibilityRoutesReevaluateJpEligibilityCriteria({
    jobId,
    jobProgramId,
    authorization,
  }: {
    jobId: any,
    jobProgramId: any,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/eligibility/{job_id}/reevaluate_eligibility_criteria/{job_program_id}',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Program Eligibility Criteria
   * Get the list of eligibility criteria for a given program.
   * @returns EligibilityCriteriaResponse Successful Response
   * @throws ApiError
   */
  public static eligibilityRoutesGetProgramEligibilityCriteria({
    jobId,
    jobProgramId,
    authorization,
  }: {
    jobId: any,
    jobProgramId: any,
    authorization?: string,
  }): CancelablePromise<Array<EligibilityCriteriaResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/eligibility/{job_id}/eligibility_criteria/{job_program_id}',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
